'use client';

import Link from "next/link";

import React from "react";

function NotFound() {
  return (
    <div className="min-h-[80vh] w-full flex items-center justify-center px-[4%]">
      <div className="text-center max-w-lg">
        <h1 className="text-[8rem] font-bold leading-none text-color-2 opacity-20">404</h1>
        <h2 className="text-2xl sm:text-3xl font-semibold text-color-2 mt-2 mb-4">
          Page Not Found
        </h2>
        <p className="text-color-2 opacity-60 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-4 justify-center flex-wrap">
          <Link
            href="/"
            className="px-6 py-2.5 bg-[var(--accent)] text-white rounded-lg hover:opacity-90 transition-opacity"
          >
            Go Home
          </Link>
          <Link
            href="/contact-us"
            className="px-6 py-2.5 border border-[var(--border-color)] text-color-2 rounded-lg hover:bg-[var(--bg-secondary)] transition-colors"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
